export const ValidateMinLength = (text, min, message) => {
    if (text && text !== null && text.length >= min)
        return null
    return message
}